export default __webpack_public_path__ + "static/home-page-bio-2-05e52d1d6801cb8c8b61b3f4f07e9da9.webp";